module.exports = __webpack_public_path__ + "static/apto-104-nw-201322d3d5c7f643b12a9edf4f158c87.jpg";